import { __decorate, __metadata } from "tslib";
import { DeferHandlerService } from '../common/defer/defer-handler.service.js';
import { SingletonService } from '@trp-dms-digital-shared/ds-ui-library-common';
const COMPONENT_LOADER_KEY_PROP_NAME = 'data-component-loader-key';
let ComponentLoaderService = class ComponentLoaderService {
    constructor() {
        this.componentLoaderDefinitionMap = new Map();
        this.deferHandlerService = new DeferHandlerService();
    }
    /**
     *
     * @param component Register the component to the service and set a key property
     */
    addComponent(component) {
        const componentKey = component.getAttribute(COMPONENT_LOADER_KEY_PROP_NAME) ||
            `${component.tagName?.toLowerCase()}-${Date.now()}`;
        const componentLoaderDefinition = {
            component: component,
            deferConditionMet: false,
        };
        if (!component.hasAttribute(COMPONENT_LOADER_KEY_PROP_NAME)) {
            component.setAttribute(COMPONENT_LOADER_KEY_PROP_NAME, componentKey);
        }
        this.componentLoaderDefinitionMap.set(componentKey, componentLoaderDefinition);
    }
    getDeferCondition(component) {
        if (component.hasAttribute(COMPONENT_LOADER_KEY_PROP_NAME)) {
            const componentKey = component.getAttribute(COMPONENT_LOADER_KEY_PROP_NAME);
            const def = this.componentLoaderDefinitionMap[componentKey];
            return def?.deferConditionMet;
        }
        return false;
    }
    /**
     * Setup the defer handler based on the type.
     * @param component
     * @returns A Promise or Array of Promiaes to be resolved before the component can be initialized
     */
    setDeferHandler(component) {
        const componentLoaderDefinition = this.componentLoaderDefinitionMap.get(component.getAttribute(COMPONENT_LOADER_KEY_PROP_NAME));
        if (!componentLoaderDefinition) {
            return new Promise((resolve) => {
                resolve();
            });
        }
        return this.deferHandlerService.createHandler(component).then(() => {
            componentLoaderDefinition.deferConditionMet = true;
        });
    }
};
ComponentLoaderService = __decorate([
    SingletonService,
    __metadata("design:paramtypes", [])
], ComponentLoaderService);
export { ComponentLoaderService };
//# sourceMappingURL=component-loader.service.js.map